import { common } from './common';
import { auth } from './auth';
import { account } from './account';
import { children } from './children';
import { hub } from './hub';
import { invite } from './invite';
import { trialBanner } from './trial-banner';
import { work } from './work';

export const en = {
  common,
  auth,
  account,
  children,
  hub,
  invite,
  trialBanner,
  work,
};
